module.exports = __webpack_public_path__ + "img/UWBprecise_localization.8624ef07.png";